module.exports = __webpack_public_path__ + "img/search.94605855.jpg";